(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits"] && !Shopify.designMode) return;
  try {
    
(function(){
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    if(!('IntersectionObserver' in window)) {
      document.querySelectorAll('.js-animate').forEach(el => el.classList.add('in-view'));
      return;
    }
    var io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('.js-animate').forEach(el => io.observe(el));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
(function(){
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){

    const faqItems = document.querySelectorAll(".faq-item");

    faqItems.forEach((item) => {
        const button = item.querySelector(".faq-question");
        const answer = item.querySelector(".faq-answer");
        const iconDown = item.querySelector(".icon-down");
        const iconRight = item.querySelector(".icon-right");

        button.addEventListener("click", () => {
        const isOpen = item.classList.contains("active");

        // Close all
        faqItems.forEach(i => {
            i.classList.remove("active");
            i.querySelector(".faq-answer").setAttribute("hidden", "true");
            i.querySelector(".icon-down").setAttribute("hidden", "true");
            i.querySelector(".icon-right").removeAttribute("hidden");
            i.querySelector(".faq-question").setAttribute("aria-expanded", "false");
        });

        // Toggle this one
        if (!isOpen) {
            item.classList.add("active");
            answer.removeAttribute("hidden");
            iconDown.removeAttribute("hidden");
            iconRight.setAttribute("hidden", "true");
            button.setAttribute("aria-expanded", "true");
        }
        });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
      var featuredSwiperswiper = new Swiper(".featuredSwiper", {
      slidesPerView: 1.39,
      spaceBetween: 20,
      // watchOverflow: true,
      // centeredSlides: true,
      // loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        disabledClass: 'my-custom-disabled-class'
      },
      breakpoints: {
        500: {
          slidesPerView:2,
          spaceBetween: 25,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-custom"] && !Shopify.designMode) return;
  try {
    
  // Accordion behavior for mobile
  document.querySelectorAll('.footer-column h3').forEach((header) => {
    header.addEventListener('click', () => {
      header.parentElement.classList.toggle('open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-multiple_slider"] && !Shopify.designMode) return;
  try {
    
  var customHeroSwiper = new Swiper('.custom-hero-slider .swiper', {
    spaceBetween: 0,
    loop: true,
    autoHeight: true,
    lazy: true,
    preloadImages: false,
    autoplay: {
       delay: 2000,
       disableOnInteraction: true,
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function(){
  const slider = document.querySelector('[data-slider]');
  if (!slider) return;

  let index = 0;
  const slides = slider.children;
  const total = slides.length;

  if(total > 1){
    setInterval(()=>{
      slides[index].style.transform = "translateX(-100%)";
      index = (index + 1) % total;
      slider.style.transform = `translateX(-${index * 100}%)`;
      slider.style.transition = "transform 0.6s ease";
    }, 1500);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  /* ======================
     VIDEO AUTOPLAY (ALWAYS)
  ====================== */
   document.querySelectorAll('.pro-video-item video').forEach(video => {
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
  });

  /* ======================
     NUTRITION OFFCANVAS
  ====================== */
  const openButtons = document.querySelectorAll(".open-nutrition");
  const offcanvas = document.querySelector("#nutritionOffcanvas");
  const overlay = document.querySelector(".offcanvas-overlay");
  const closeButtons = document.querySelectorAll(".close-offcanvas");

  if (openButtons.length && offcanvas && overlay) {

    openButtons.forEach(btn => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        offcanvas.classList.add("active");
        overlay.classList.add("active");
      });
    });

    function closeNutritionPanel() {
      offcanvas.classList.remove("active");
      overlay.classList.remove("active");
    }

    closeButtons.forEach(btn => {
      btn.addEventListener("click", closeNutritionPanel);
    });

    overlay.addEventListener("click", closeNutritionPanel);
  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-packaging"] && !Shopify.designMode) return;
  try {
    
  var packagingSlider = new Swiper('.product-packaging__slider', {
    slidesPerView: 1.5,
    spaceBetween: 16,
    // loop: true,
    breakpoints: {
      576: {
          slidesPerView:2,
          spaceBetween: 20,
      },
      768: {
        slidesPerView: 3
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonal-slider"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".testimonial-swiper", {
      slidesPerView: 1,
      // centeredSlides: true,
      spaceBetween: 10,
      // cssMode: true,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }, 
      breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 26,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 32,
        },
        autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonial-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    // Init Swiper
    const videoSwiper = new Swiper('.video-grid.swiper', {
    slidesPerView: 6,
    spaceBetween: 16,
    // loop: true,
    breakpoints: {
        0: {
        slidesPerView: 1.6, // one full + peek of next
        spaceBetween: 16,
        },
        768: {
        slidesPerView: 3,
        spaceBetween: 16,
        },
        1200: {
        slidesPerView: 6,
        spaceBetween: 16,
        }
    }
    });

    // Hover autoplay on desktop
    document.querySelectorAll('.video-item video').forEach(video => {
    video.addEventListener('mouseenter', () => video.play());
    video.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0;
    });
    });

    // Mobile autoplay sequentially
    if (window.matchMedia("(max-width: 767px)").matches) {
    const videos = document.querySelectorAll('.video-item video');
    let index = 0;

    function playNext() {
        videos.forEach(v => { v.pause(); v.currentTime = 0; });
        if (videos[index]) {
        videos[index].play();
        videos[index].onended = () => {
            index = (index + 1) % videos.length;
            playNext();
        };
        }
    }

    if (videos.length > 0) playNext();
    }
});

  } catch(e) { console.error(e); }
})();
})();
